<form class="modal-body wrapper-modal position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>

    <section class="py-0 px-2 px-md-3 px-lg-4">
        <p class="title mx-3">
            Replicar cambios
        </p>
        <p class="mb-2 destination-hint">
            Vas a replicar la información del servicio
            <strong>{{ data?.cargo?.consecutive }}</strong>
            en otros servicios. Solo puedes seleccionar servicios destino que estén en estado de
            <strong>"Solicitud"</strong>.
        </p>

        <h6 class="section-subtitle">Servicio origen</h6>
        <div class="origin-cargo-compact mb-3">
            <div class="origin-cargo-compact__grid">
                <div class="origin-cargo-compact__item origin-cargo-compact__item--consecutive">
                    <span class="label">Consecutivo</span>
                    <span class="value cargo-consecutive-link cursor-pointer"
                        *ngIf="data?.cargo && (data.cargo.consecutive || data.cargo.consecutive === 0)"
                        (click)="openCargoInNewTab(data.cargo, $event)">
                        {{ data.cargo.consecutive }}
                    </span>
                    <span class="value"
                        *ngIf="!data?.cargo || (!data.cargo.consecutive && data.cargo.consecutive !== 0)">-</span>
                </div>
                <div class="origin-cargo-compact__item">
                    <span class="label">Contratante</span>
                    <span class="value" *ngIf="data?.cargo?.ministry">{{ data?.cargo?.cargoOwner?.name || '-' }}</span>
                    <span class="value" *ngIf="!data?.cargo?.ministry">{{ data?.cargo?.idCompany | companyName }}</span>
                </div>
                <div class="origin-cargo-compact__item">
                    <span class="label">Origen</span>
                    <span class="value">{{ data?.cargo?.cargoFeature?.uploadDownload?.origin?.name || '-' }}</span>
                </div>
                <div class="origin-cargo-compact__item">
                    <span class="label">Fecha origen</span>
                    <span class="value">{{ data?.cargo?.dateLoad | dateFormat:'only-date' }}</span>
                </div>
                <div class="origin-cargo-compact__item">
                    <span class="label">Destino</span>
                    <span class="value">{{ getCargoLastDestination(data?.cargo)?.name || '-' }}</span>
                </div>
                <div class="origin-cargo-compact__item">
                    <span class="label">Fecha destino</span>
                    <span class="value">{{ getCargoLastDestination(data?.cargo)?.downloadDate | dateFormat:'only-date'
                        }}</span>
                </div>
            </div>
        </div>

        <h6 class="section-subtitle">Servicios destino</h6>
        <p class="mb-2 destination-hint">
            Selecciona los servicios destino directamente en la tabla o ingresa los consecutivos separados por comas y
            haz clic en <strong>"Buscar"</strong> para seleccionarlos.
        </p>

        <div class="d-flex flex-wrap mb-2 align-items-baseline">
            <mat-form-field class="col-sm-8">
                <mat-label>Consecutivos</mat-label>
                <input matInput type="text" placeholder="Digita los consecutivos" [formControl]="consecutivesControl">
            </mat-form-field>
            <div class="col-sm-4">
                <button type="button" mat-raised-button class="primary-secondary w-100" color="primary"
                    (click)="searchConsecutives()">Buscar</button>
            </div>
        </div>

        <div class="destination-table-wrapper" *ngIf="targetCargos.length">
            <table class="destination-table">
                <thead>
                    <tr>
                        <th class="col-check">
                            <mat-checkbox [checked]="allValidSelected" [indeterminate]="someValidSelected"
                                [disabled]="!validTargetCargos.length" (change)="toggleSelectAll($event.checked)">
                            </mat-checkbox>
                        </th>
                        <th>Consecutivo</th>
                        <th>Contratante</th>
                        <th>Origen</th>
                        <th>Fecha origen</th>
                        <th>Destino</th>
                        <th>Fecha destino</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of targetCargos; let i = index" class="destination-table__row"
                        [class.destination-table__row--error]="row.errorMessage"
                        [class.destination-table__row--selected]="row.checked && !row.errorMessage">
                        <td class="col-check">
                            <mat-checkbox [checked]="row.checked" [disabled]="!!row.errorMessage"
                                (change)="setCargoChecked(i, $event.checked)">
                            </mat-checkbox>
                        </td>
                        <td class="col-consecutive">
                            <span class="cargo-consecutive-link cursor-pointer"
                                *ngIf="row.cargo && (row.cargo.consecutive || row.cargo.consecutive === 0)"
                                (click)="openCargoInNewTab(row.cargo, $event)">
                                {{ row.cargo.consecutive }}
                            </span>
                            <span *ngIf="!row.cargo || (!row.cargo.consecutive && row.cargo.consecutive !== 0)">-</span>
                            <i *ngIf="row.errorMessage"
                                class="fas fa-exclamation-circle destination-table__error-icon cursor-pointer"
                                aria-hidden="true" [matTooltip]="row.errorMessage" matTooltipClass="tooltip__error"
                                matTooltipPosition="right"></i>
                        </td>
                        <td>
                            <span *ngIf="row.cargo?.ministry">{{ row.cargo?.cargoOwner?.name || '-' }}</span>
                            <span *ngIf="!row.cargo?.ministry">{{ row.cargo?.idCompany | companyName }}</span>
                        </td>
                        <td>{{ row.cargo?.cargoFeature?.uploadDownload?.origin?.name || '-' }}</td>
                        <td>{{ row.cargo?.dateLoad | dateFormat:'only-date' }}</td>
                        <td>{{ getCargoLastDestination(row.cargo)?.name || '-' }}</td>
                        <td>{{ getCargoLastDestination(row.cargo)?.downloadDate | dateFormat:'only-date' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <p *ngIf="!targetCargos.length" class="destination-empty text-muted mb-3">
            No hay servicios destino. Busca consecutivos para agregarlos a la tabla.
        </p>

        <div class="button-container mt-2">
            <button type="button" mat-raised-button color="primary" class="bg-color-primary" (click)="onSubmit()">
                Replicar cambios
            </button>
        </div>
    </section>
</form>